import { configureStore } from '@reduxjs/toolkit'

import checkoutReducer, { switchCatalog } from '@/features/CashierDesk/store/checkoutSlice'
import { broadcastState } from '@/lib/broadcastSync'
import i18n from '@/lib/i18n'
import { getClientType } from '@/services/clientConfig'
import { resolveTheme } from '@/themes/clients'

const store = configureStore({
  reducer: {
    checkout: checkoutReducer
  }
})

let broadcastCount = 0

// Broadcast checkout state to customer display on every change
store.subscribe(() => {
  const { checkout } = store.getState()
  broadcastCount++
  console.log(`[STORE] State changed (#${broadcastCount}), cart=${checkout.cart.length} items, broadcasting...`)
  broadcastState(checkout)
})

// Switching language may switch the brand (Bestway <-> Salvia): move the cart to the
// new catalogue; the resulting state change is broadcast so the customer display follows
i18n.on('languageChanged', lng => {
  if (window.location.pathname.startsWith('/customer')) return
  store.dispatch(switchCatalog(resolveTheme(getClientType(), lng).products))
})

// Heartbeat: a customer display that (re)connects later still gets the current
// brand, language and cart without waiting for the next checkout change
if (!window.location.pathname.startsWith('/customer')) {
  setInterval(() => broadcastState(store.getState().checkout, { quiet: true }), 3000)
}

export default store
